<div class="rrss" [ngClass]="customClass">
  <div
    class="sidebar-icon"
    role="button"
    tabindex="0"
    aria-label="Compartir"
    [attr.aria-expanded]="rrssVisible"
    (click)="mostrarRRSS()"
    (keydown.enter)="mostrarRRSS()"
    (keydown.space)="mostrarRRSS(); $event.preventDefault()"
  >
    <ng-content select="[toggleIcon]">
      <app-icon-share [selected]="rrssVisible" [shared]="sharedIcon"></app-icon-share>
    </ng-content>
  </div>
  <div class="rrss_container theme-{{ theme }}" [style.display]="rrssVisible ? 'flex' : 'none'">
    <a href="https://www.facebook.com/sharer/sharer.php?u={{ url }}" target="_blank" aria-label="Compartir en Facebook">
      <img src="assets/images/facebook.webp" alt="Facebook" class="icons" loading="lazy" />
    </a>
    <a href="https://twitter.com/intent/tweet?text={{ url }}" data-size="large" target="_blank" aria-label="Compartir en Twitter">
      <img src="assets/images/x.webp" alt="Twitter" class="icons" loading="lazy" />
    </a>
    <a href="https://api.whatsapp.com/send?text={{ text }} - {{ url }}" data-action="share/whatsapp/share" target="_blank" aria-label="Compartir en Whatsapp">
      <img src="assets/images/whatsapp.webp" alt="Whatsapp" class="icons" loading="lazy" />
    </a>
    <a href="https://www.linkedin.com/sharing/share-offsite/?url={{ text }} - {{ url }}" target="_blank" aria-label="Compartir en LinkedIn">
      <img src="assets/images/linkedin.webp" alt="Linkedin" class="icons" loading="lazy" />
    </a>
  </div>
</div>
